export default {
      id: "i-noun-science-usage",
      viewBox: "0 0 43 44",
      url: __webpack_public_path__ + "img/sprite.svg#i-noun-science",
      toString: function () {
        return this.url;
      }
    }